import thunkMiddleware from 'redux-thunk';

const middlewares = [
  thunkMiddleware
];

export default middlewares;
